import SelectWithFetch from './SelectWithFetch';
import getClientDocumentTypes from '../../api/clients/getClientDocumentTypes';

const SelectClientDocumentType = (props) => {
  return <SelectWithFetch fetch={getClientDocumentTypes} {...props} placeholder="Выберите из списка" />;
};

export default SelectClientDocumentType;
